import useSWR from "swr";
import { TaskModel } from "../models/TaskModels";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { ToastContext } from "../context/ToastContext";
import { useContext } from "react";

export const useTasksEmail = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<TaskModel[]>(
    `${environment.apiUrl}/api/emails/tasks`,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get tasks, please try again later", "error");
      },
    }
  );

  return {
    tasks: data,
    isLoading,
    isError: !!error,
  };
};
